module.exports = __webpack_public_path__ + "static/media/shape-bg.243d823a.png";